// // import React, { useState, useEffect, useRef } from "react";
// // import { Link, useParams, useNavigate } from "react-router-dom";
// // import Slider from "react-slick";
// // import "slick-carousel/slick/slick.css";
// // import "slick-carousel/slick/slick-theme.css";
// // import httpClient from "../../utils/httpClients";
// // import { usePlayer } from "../../../PlayerContext";

// // function AdminPlaylist() {
// //   const { id } = useParams();
// //   const navigate = useNavigate();
// //   const sliderRef = useRef(null);

// //   const [musics, setMusics] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [openDropdown, setOpenDropdown] = useState(null);
// //   const [likedSongs, setLikedSongs] = useState(new Set());
// //   const [sharePopup, setSharePopup] = useState({ open: false, song: null });
// //   const [playCountTracked, setPlayCountTracked] = useState(false);
// //   const playTimerRef = useRef(null);
// //   const [genres, setGenres] = useState([]);

// //   const [playlistModal, setPlaylistModal] = useState({
// //     open: false,
// //     song: null,
// //   });
// //   const [playlists, setPlaylists] = useState([]);
// //   const [newPlaylist, setNewPlaylist] = useState({
// //     name: "",
// //     description: "",
// //     coverImage: null,
// //   });
// //   const [showCreateForm, setShowCreateForm] = useState(false);
// //   const [playlistLoading, setPlaylistLoading] = useState(false);

// //   const {
// //     isPlaying,
// //     currentTrack,
// //     togglePlayPause,
// //     seek,
// //     duration,
// //     triggerQueueUpdate,
// //     playTrackById,
// //     tracks,
// //     currentTrackIndex,
// //   } = usePlayer();

// //   // Fetch playlists
// //   const fetchPlaylists = async () => {
// //     try {
// //       const res = await httpClient.get("/user/playlist/get-playlists");
// //       if (res.data && res.data.success) {
// //         setPlaylists(res.data.data.playlist || []);
// //       }
// //     } catch (err) {
// //       console.error("Error fetching playlists:", err);
// //     }
// //   };

// //   // Open playlist modal
// //   const openPlaylistModal = (song, e) => {
// //     e.preventDefault();
// //     e.stopPropagation();
// //     setPlaylistModal({ open: true, song });
// //     fetchPlaylists();
// //     setOpenDropdown(null);
// //   };

// //   // Close playlist modal
// //   const closePlaylistModal = () => {
// //     setPlaylistModal({ open: false, song: null });
// //     setShowCreateForm(false);
// //     setNewPlaylist({ name: "", description: "", coverImage: null });
// //   };

// //   // Create new playlist
// //   const createNewPlaylist = async () => {
// //     if (!newPlaylist.name.trim()) {
// //       alert("Please enter playlist name");
// //       return;
// //     }

// //     try {
// //       setPlaylistLoading(true);
// //       const formData = new FormData();
// //       formData.append("name", newPlaylist.name);
// //       formData.append("description", newPlaylist.description);
// //       if (newPlaylist.coverImage) {
// //         formData.append("coverImage", newPlaylist.coverImage);
// //       }

// //       const res = await httpClient.post(
// //         "/user/playlist/create-playlist",
// //         formData,
// //         {
// //           headers: {
// //             "Content-Type": "multipart/form-data",
// //           },
// //         }
// //       );

// //       if (res.data && res.data.success) {
// //         // Refresh playlists
// //         await fetchPlaylists();
// //         setShowCreateForm(false);
// //         setNewPlaylist({ name: "", description: "", coverImage: null });

// //         // If there's a song selected, add it to the new playlist
// //         if (playlistModal.song) {
// //           await addToPlaylist(res.data.data.playlist._id, playlistModal.song._id);
// //         }
// //       }
// //     } catch (err) {
// //       console.error("Error creating playlist:", err);
// //       alert("Failed to create playlist");
// //     } finally {
// //       setPlaylistLoading(false);
// //     }
// //   };

// //   // Add song to playlist
// //   const addToPlaylist = async (playlistId, songId) => {
// //     try {
// //       const params = new URLSearchParams({
// //         playlistId: playlistId,
// //         itemId: songId,
// //         itemType: "Music",
// //       });

// //       const res = await httpClient.post(`/user/playlist/add-item?${params}`);

// //       if (res.data && res.data.success) {
// //         closePlaylistModal();
// //       } else {
// //       }
// //     } catch (err) {
// //       console.error("Error adding song to playlist:", err);
// //     }
// //   };

// //   // Handle file input for cover image
// //   const handleFileChange = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       setNewPlaylist((prev) => ({
// //         ...prev,
// //         coverImage: file,
// //       }));
// //     }
// //   };

// //   // Share popup functions
// //   const openSharePopup = (song, e) => {
// //     e.preventDefault();
// //     e.stopPropagation();
// //     setSharePopup({ open: true, song });
// //   };

// //   const closeSharePopup = () => {
// //     setSharePopup({ open: false, song: null });
// //   };
// //  const fetchGenresSongs = async () => {
// //     try {
// //       setError(null);
// //       const res = await httpClient.get(`/user/music/get-themes`);

// //       if (res.data?.success) {
// //         const data = res.data.data.getThemes || [];
// //         setGenres(data);
// //       } else {
// //         setError("Failed to fetch genre data");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setError("Error fetching genre data");
// //     }
// //   };
// //  useEffect(() => {
// //     window.scrollTo(0, 0);
// //   }, []);
// //  useEffect(() => {
// //     fetchGenresSongs();
// //   }, []);
// //   const handleCopy = async () => {
// //     const text = generateShareableUrl(sharePopup.song._id);

// //     try {
// //       await navigator.clipboard.writeText(text);
// //     } catch (err) {
// //       console.error("Failed to copy: ", err);

// //       // Fallback for older browsers
// //       const textArea = document.createElement("textarea");
// //       textArea.value = text;
// //       textArea.style.position = "fixed";
// //       textArea.style.top = 0;
// //       textArea.style.left = 0;
// //       textArea.style.width = "2em";
// //       textArea.style.height = "2em";
// //       textArea.style.padding = 0;
// //       textArea.style.border = "none";
// //       textArea.style.outline = "none";
// //       textArea.style.boxShadow = "none";
// //       textArea.style.background = "transparent";

// //       document.body.appendChild(textArea);
// //       textArea.select();

// //       try {
// //         document.execCommand("copy");
// //       } catch (err) {
// //         alert("Failed to copy text!");
// //       }

// //       document.body.removeChild(textArea);
// //     }
// //   };

// //   const isSongCurrentlyPlaying = (songId) => {
// //     return currentTrack && currentTrack._id === songId;
// //   };

// //   const getQueuePosition = (songId) => {
// //     const index = tracks.findIndex((track) => track._id === songId);
// //     return index >= 0 ? index + 1 : null;
// //   };

// //   const handleQueueAction = async (action, trackId = null) => {
// //     try {
// //       const payload = { action };
// //       if (trackId) {
// //         payload.trackId = trackId;
// //       }

// //       const res = await httpClient.post("user/queue/queue-controller", payload);

// //       if (res.data && res.data.success) {
// //         triggerQueueUpdate();
// //         return true;
// //       } else {
// //         console.error("Queue action failed:", res.data);
// //         return false;
// //       }
// //     } catch (error) {
// //       console.error("Queue action error:", error);
// //       return false;
// //     }
// //   };

// //   const formatDuration = (seconds) => {
// //     if (!seconds || isNaN(seconds)) return "0:00";
// //     const mins = Math.floor(seconds / 60);
// //     const secs = Math.floor(seconds % 60);
// //     return `${mins}:${secs.toString().padStart(2, "0")}`;
// //   };

// //   const fetchPlayMusics = async () => {
// //     try {
// //       setLoading(true);
// //       setError(null);

// //       const res = await httpClient.get(
// //         `user/music/get-admin-playlist-songs/${id}`
// //       );

// //       if (res.data && res.data.success) {
// //         const musicData = res.data.data?.songs || [];
// //         setMusics(musicData);

// //         const likedSongIds = new Set();
// //         musicData.forEach((music) => {
// //           if (music.isLiked) {
// //             likedSongIds.add(music._id);
// //           }
// //         });
// //         setLikedSongs(likedSongIds);

// //         console.log("📊 Playlist songs loaded:", musicData.length);
// //       } else {
// //         setError("Failed to fetch playlist data");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setError("Error fetching playlist musics");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleLikeSong = async (contentId, isCurrentlyLiked) => {
// //     try {
// //       const action = isCurrentlyLiked ? "dislike" : "like";
// //       const res = await httpClient.post(
// //         `/user/play-history/like-content/${contentId}/${action}`
// //       );

// //       if (res.data && res.data.success) {
// //         const newLikedSongs = new Set(likedSongs);
// //         if (isCurrentlyLiked) newLikedSongs.delete(contentId);
// //         else newLikedSongs.add(contentId);
// //         setLikedSongs(newLikedSongs);

// //         const updatedMusics = musics.map((music) =>
// //           music._id === contentId ? { ...music, isLiked: !isCurrentlyLiked } : music
// //         );
// //         setMusics(updatedMusics);
// //       }
// //     } catch (err) {
// //       console.error("Error liking/disliking song:", err);
// //     }
// //   };

// //   const playSong = async (song, index) => {
// //     console.log("🎵 Playing song from playlist:", song.title, "ID:", song._id);
// //     await handleQueueAction("addAndPlay", song._id);
// //   };

// //   // --- Play Count Logic ---
// //   const recordPlayCount = async (contentId) => {
// //     try {
// //       await httpClient.post(`user/play-history/content-play-count/${contentId}`);
// //       console.log("✅ Play count recorded for:", contentId);
// //       setPlayCountTracked(true);
// //     } catch (error) {
// //       console.error("❌ Error recording play count:", error);
// //     }
// //   };

// //   const startPlayCountTimer = (contentId) => {
// //     if (!playCountTracked && contentId) {
// //       if (playTimerRef.current) clearTimeout(playTimerRef.current);
// //       playTimerRef.current = setTimeout(() => {
// //         recordPlayCount(contentId);
// //       }, 10000); // 10s continuous playback
// //     }
// //   };

// //   useEffect(() => {
// //     if (currentTrack) {
// //       setPlayCountTracked(false);
// //       if (playTimerRef.current) clearTimeout(playTimerRef.current);
// //     }
// //   }, [currentTrack]);

// //   useEffect(() => {
// //     if (currentTrack) {
// //       if (isPlaying) {
// //         startPlayCountTimer(currentTrack._id);
// //       } else {
// //         if (playTimerRef.current) clearTimeout(playTimerRef.current);
// //       }
// //     }

// //     return () => {
// //       if (playTimerRef.current) clearTimeout(playTimerRef.current);
// //     };
// //   }, [isPlaying, currentTrack]);

// //   const playAllSongs = async () => {
// //     if (musics.length > 0) {
// //       await handleQueueAction("addAndPlay", musics[0]._id);
// //     }
// //   };

// //   const addToQueue = async (trackId) => {
// //     await handleQueueAction("add", trackId);
// //   };

// //   const sendToArtist = (artistId) => {
// //     if (artistId) navigate(`/art/${artistId}`);
// //   };

// //   const sendToAlbum = (albumId, isAlbum) => {
// //     if (isAlbum && albumId) navigate(`/album/${albumId}`);
// //   };

// //   const toggleDropdown = (contentId) => {
// //     setOpenDropdown(openDropdown === contentId ? null : contentId);
// //   };

// //   // Close dropdowns and share popup when clicking outside
// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (!event.target.closest(".dropdown")) {
// //         setOpenDropdown(null);
// //       }
// //       if (
// //         !event.target.closest(".share-popup") &&
// //         !event.target.closest(".single-item__export")
// //       ) {
// //         closeSharePopup();
// //       }
// //       if (
// //         !event.target.closest(".playlist-popup") &&
// //         !event.target.closest(".dropdown-item")
// //       ) {
// //         closePlaylistModal();
// //       }
// //     };

// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, []);

// //   useEffect(() => {
// //     if (id) {
// //       fetchPlayMusics();
// //     }
// //   }, [id]);

// //   const generateShareableUrl = (songId) => {
// //     const encodedSongId = encodeURIComponent(songId);
// //     return `https://webmobrildemo.com/volumetv/music/${encodedSongId}`;
// //   };

// //   const shareOnSocialMedia = (platform, song) => {
// //     const shareUrl = generateShareableUrl(song._id);
// //     const shareText = encodeURIComponent(song.title);

// //     const shareUrls = {
// //       facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
// //       twitter: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareText}`,
// //       whatsapp: `https://api.whatsapp.com/send?text=${shareText}%20${shareUrl}`,
// //       telegram: `https://t.me/share/url?url=${shareUrl}&text=${shareText}`,
// //     };

// //     if (shareUrls[platform]) {
// //       window.open(shareUrls[platform], "_blank", "width=600,height=400");
// //     }
// //   };

// //   // React Slick settings for genres carousel
// //   const sliderSettings = {
// //     dots: false,
// //     infinite: true,
// //     speed: 500,
// //     slidesToShow: 6,
// //     slidesToScroll: 3,
// //     arrows: false,
// //     responsive: [
// //       {
// //         breakpoint: 1024,
// //         settings: {
// //           slidesToShow: 4,
// //           slidesToScroll: 3,
// //         },
// //       },
// //       {
// //         breakpoint: 768,
// //         settings: {
// //           slidesToShow: 3,
// //           slidesToScroll: 2,
// //         },
// //       },
// //       {
// //         breakpoint: 480,
// //         settings: {
// //           slidesToShow: 2,
// //           slidesToScroll: 1,
// //         },
// //       },
// //     ],
// //   };

// //   const CustomNextArrow = () => (
// //     <div
// //       className="swiper-button-next"
// //       id="next1"
// //       tabIndex={0}
// //       role="button"
// //       aria-label="Next slide"
// //       onClick={() => sliderRef.current && sliderRef.current.slickNext()}
// //       style={{ cursor: "pointer" }}
// //     >
// //       <svg
// //         xmlns="http://www.w3.org/2000/svg"
// //         width="18"
// //         height="19"
// //         viewBox="0 0 18 19"
// //         fill="none"
// //       >
// //         <path
// //           d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
// //           fill="currentColor"
// //         />
// //       </svg>
// //     </div>
// //   );

// //   const CustomPrevArrow = () => (
// //     <div
// //       className="swiper-button-prev"
// //       id="prev1"
// //       tabIndex={0}
// //       role="button"
// //       aria-label="Previous slide"
// //       onClick={() => sliderRef.current && sliderRef.current.slickPrev()}
// //       style={{ cursor: "pointer" }}
// //     >
// //       <svg
// //         xmlns="http://www.w3.org/2000/svg"
// //         width="18"
// //         height="19"
// //         viewBox="0 0 18 19"
// //         fill="none"
// //       >
// //         <path
// //           d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
// //           fill="#4A525F"
// //         />
// //       </svg>
// //     </div>
// //   );

// //   if (loading) {
// //     return (
// //       <div className="content-inner pb-0 container-fluid" id="page_layout">
// //         <div
// //           className="d-flex justify-content-center align-items-center"
// //           style={{ height: "50vh" }}
// //         >
// //           <div className="spinner-border text-primary" role="status">
// //             <span className="sr-only">Loading...</span>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   }

// //   if (error) {
// //     return (
// //       <div className="content-inner pb-0 container-fluid" id="page_layout">
// //         <div className="alert alert-danger" role="alert">
// //           {error}
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="content-inner pb-0 container-fluid" id="page_layout">
// //       <div className="row row--grid">
// //         {/* breadcrumb */}
// //         <div className="col-12">
// //           <ul className="breadcrumb">
// //             <li className="breadcrumb__item">
// //               <Link to="/">Home</Link>
// //             </li>
// //             <li className="breadcrumb__item breadcrumb__item--active">
// //               Play List Music
// //             </li>
// //           </ul>
// //         </div>
// //         {/* end breadcrumb */}
// //         <div className="col-12">
// //           <div className="main__title main__title--page">
// //             <h1>Playlist Music</h1>
// //           </div>
// //         </div>
// //         {/* end title */}
// //         <div className="col-12">
// //           <div className="release">
// //             <div className="release__content">
// //               <div className="release__cover">
// //                 <img src={`${process.env.PUBLIC_URL}/img/covers/cover3.jpg`} alt="cover" />
// //               </div>
// //               <div className="release__stat">
// //                 <span>
// //                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
// //                     <path d="M21.65,2.24a1,1,0,0,0-.8-.23l-13,2A1,1,0,0,0,7,5V15.35A3.45,3.45,0,0,0,5.5,15,3.5,3.5,0,1,0,9,18.5V10.86L20,9.17v4.18A3.45,3.45,0,0,0,18.5,13,3.5,3.5,0,1,0,22,16.5V3A1,1,0,0,0,21.65,2.24ZM5.5,20A1.5,1.5,0,1,1,7,18.5,1.5,1.5,0,0,1,5.5,20Zm13-2A1.5,1.5,0,1,1,20,16.5,1.5,1.5,0,0,1,18.5,18ZM20,7.14,9,8.83v-3L20,4.17Z" />
// //                   </svg>{" "}
// //                   {musics.length} tracks
// //                 </span>
// //                 <span>
// //                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
// //                     <path d="M20,13.18V11A8,8,0,0,0,4,11v2.18A3,3,0,0,0,2,16v2a3,3,0,0,0,3,3H8a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H6V11a6,6,0,0,1,12,0v2H16a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h3a3,3,0,0,0,3-3V16A3,3,0,0,0,20,13.18ZM7,15v4H5a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1Zm13,3a1,1,0,0,1-1,1H17V15h2a1,1,0,0,1,1,1Z" />
// //                   </svg>{" "}
// //                   {currentTrack?.playCount || 0}
// //                 </span>
// //               </div>
// //               <div className="d-flex justify-content-between gap-3">
// //                 <a
// //                   className="release__buy open-modal"
// //                   onClick={togglePlayPause}
// //                   disabled={!currentTrack}
// //                 >
// //                   <i className={isPlaying ? "fas fa-pause" : "fas fa-play"}></i>
// //                   {isPlaying ? "Pause" : "Play"}
// //                 </a>
// //               </div>
// //             </div>
// //             <div className="release__list">
// //               <ul className="main__list main__list--playlist main__list--dashbox">
// //                 <h4 className="card-title text-capitalize episodes">All Tracks</h4>
// //                 {musics.map((music, index) => {
// //                   const contentId = music?._id;
// //                   const isLiked = likedSongs.has(contentId);
// //                   const isCurrentlyPlaying = isSongCurrentlyPlaying(contentId);
// //                   const queuePosition = getQueuePosition(contentId);
// //                   const isDropdownOpen = openDropdown === contentId;
// //                   const ArtistId = music.artistIds?.[0];
// //                   const isAlbum = music.isAlbum;
// //                   const AlbumId = music.parentId;

// //                   return (
// //                     <li
// //                       key={contentId}
// //                       className={`single-item list-1 ${
// //                         isCurrentlyPlaying ? "active-episode" : ""
// //                       }`}
// //                       style={{
// //                         backgroundColor: isCurrentlyPlaying
// //                           ? "rgba(255, 255, 255, 0.1)"
// //                           : "transparent",
// //                         borderLeft: isCurrentlyPlaying
// //                           ? "3px solid #1DB954"
// //                           : "3px solid transparent",
// //                       }}
// //                     >
// //                       {/* Song Cover with Play Button */}
// //                       <div
// //                         className="single-item__cover"
// //                         onClick={() => playSong(music, index)}
// //                         style={{ cursor: "pointer", color: "#fff" }}
// //                       >
// //                         <img
// //                           src={
// //                             music?.coverImageUrl ||
// //                             `${process.env.PUBLIC_URL}/img/covers/cover.svg`
// //                           }
// //                           alt={music.title}
// //                         />
// //                         {isCurrentlyPlaying && isPlaying ? (
// //                           <svg
// //                             xmlns="http://www.w3.org/2000/svg"
// //                             viewBox="0 0 24 24"
// //                             style={{ fill: "#1DB954" }}
// //                           >
// //                             <path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z" />
// //                           </svg>
// //                         ) : (
// //                           <svg
// //                             xmlns="http://www.w3.org/2000/svg"
// //                             viewBox="0 0 24 24"
// //                             style={{
// //                               fill: isCurrentlyPlaying ? "#1DB954" : "#FFFFFF",
// //                             }}
// //                           >
// //                             <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
// //                           </svg>
// //                         )}
// //                       </div>

// //                       {/* Song Title and Artist */}
// //                       <div className="single-item__title">
// //                         <h4
// //                           onClick={() => isAlbum && sendToAlbum(AlbumId, isAlbum)}
// //                           style={{ cursor: isAlbum ? "pointer" : "default" }}
// //                         >
// //                           {index + 1}. {music.title}
// //                           {isCurrentlyPlaying && (
// //                             <span
// //                               className="badge bg-success ms-2"
// // style={{ fontSize: "0.7em", color: "#fff" }}
// //                             >
// //                               ▶️ Playing
// //                             </span>
// //                           )}
// //                           {queuePosition && !isCurrentlyPlaying && (
// //                             <span
// //                               className="badge bg-info ms-2"
// // style={{ fontSize: "0.7em", color: "#fff" }}
// //                             >
// //                               #{queuePosition} in Queue
// //                             </span>
// //                           )}
// //                         </h4>

// //                         {/* Artist Name clickable */}
// //                         <span
// //                           onClick={() => sendToArtist(ArtistId)}
// //                           style={{
// //                             cursor: ArtistId ? "pointer" : "default",
// //                             color: "#1DB954",
// //                           }}
// //                         >
// //                           {music.artist || "Unknown Artist"}
// //                         </span>
// //                       </div>

// //                       {/* Dropdown Menu */}
// //                       <div className="dropdown">
// //                         <span
// //                           className={`d-flex align-items-center h5 mb-0 ${
// //                             isDropdownOpen ? "show" : ""
// //                           }`}
// //                           onClick={() => toggleDropdown(contentId)}
// //                           aria-expanded={isDropdownOpen}
// //                           style={{ cursor: "pointer", color: "#fff" }}
// //                         >
// //                           <i className="fas fa-ellipsis-h"></i>
// //                         </span>
// //                         <div
// //                           className={`dropdown-menu dropdown-menu-end ${
// //                             isDropdownOpen ? "show" : ""
// //                           }`}
// //                           style={
// //                             isDropdownOpen
// //                               ? {
// //                                   position: "absolute",
// //                                   inset: "0px 0px auto auto",
// //                                   margin: "0px",
// //                                   transform: "translate(0px, 19px)",
// //                                 }
// //                               : {}
// //                           }
// //                         >
// //                           <a
// //                             className="dropdown-item"
// //                             href="#!"
// //                             onClick={(e) => openPlaylistModal(music, e)}
// //                           >
// //                             <span className="material-icons">
// //                               library_music
// //                             </span>
// //                             Add To Playlist
// //                           </a>
// //                           <a
// //                             className="dropdown-item"
// //                             href="#!"
// //                             onClick={(e) => {
// //                               e.preventDefault();
// //                               addToQueue(contentId);
// //                               setOpenDropdown(null);
// //                             }}
// //                           >
// //                             <span className="material-icons">
// //                               playlist_add
// //                             </span>
// //                             Add To Queue
// //                           </a>
// //                           <a
// //                             className={`dropdown-item ${
// //                               !ArtistId ? "disabled" : ""
// //                             }`}
// //                             href="#!"
// //                             onClick={(e) => {
// //                               e.preventDefault();
// //                               if (ArtistId) {
// //                                 sendToArtist(ArtistId);
// //                                 setOpenDropdown(null);
// //                               }
// //                             }}
// //                           >
// //                             <span className="material-icons">music_note</span>
// //                             Go To Artist
// //                           </a>

// //                           <a
// //                             className={`dropdown-item ${
// //                               !isAlbum ? "disabled" : ""
// //                             }`}
// //                             href="#!"
// //                             onClick={(e) => {
// //                               e.preventDefault();
// //                               if (isAlbum) {
// //                                 sendToAlbum(AlbumId, isAlbum);
// //                                 setOpenDropdown(null);
// //                               }
// //                             }}
// //                           >
// //                             <span className="material-icons">album</span>
// //                             Go To Album
// //                           </a>
// //                         </div>
// //                       </div>

// //                       {/* Like Button */}
// //                       <a
// //                         href="#!"
// //                         className={`single-item__add ${isLiked ? "liked" : ""}`}
// //                         onClick={(e) => {
// //                           e.preventDefault();
// //                           handleLikeSong(contentId, isLiked);
// //                         }}
// //                       >
// //                         <i
// //                           className={isLiked ? "fas fa-heart" : "far fa-heart"}
// //                         ></i>
// //                       </a>

// //                       {/* Share Button */}
// //                       <a
// //                         href="#!"
// //                         className="single-item__export"
// //                         onClick={(e) => openSharePopup(music, e)}
// //                       >
// //                         <i className="fas fa-share"></i>
// //                       </a>

// //                       {/* Time Display */}
// //                       <span className="single-item__time">
// //                         {isCurrentlyPlaying
// //                           ? `${formatDuration(seek)} / ${formatDuration(duration)}`
// //                           : formatDuration(music.duration)}
// //                       </span>
// //                     </li>
// //                   );
// //                 })}
// //               </ul>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Top Genres Section - Fixed with exact same HTML structure */}
// //       <div className="row">
// //         <div className="col-lg-12 mb-5">
// //           <div className="card-header mb-3">
// //             <div className="header-title">
// //               <h4 className="card-title text-capitalize">
// //                 top song genres for you
// //               </h4>
// //             </div>
// //             <div className="common-album position-relative d-lg-block d-none">
// //               <div
// //                 className="swiper-button-prev"
// //                 id="prev"
// //                 tabIndex={0}
// //                 role="button"
// //                 aria-label="Previous slide"
// //                 aria-controls="swiper-wrapper-eff510bae5fc34b53"
// //                 onClick={() => sliderRef.current?.slickPrev()}
// //                 style={{ cursor: "pointer" }}
// //               >
// //                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
// //                   <path d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z" fill="#4A525F"></path>
// //                 </svg>
// //               </div>
// //               <div
// //                 className="swiper-button-next"
// //                 id="next"
// //                 tabIndex={0}
// //                 role="button"
// //                 aria-label="Next slide"
// //                 aria-controls="swiper-wrapper-eff510bae5fc34b53"
// //                 onClick={() => sliderRef.current?.slickNext()}
// //                 style={{ cursor: "pointer" }}
// //               >
// //                 <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
// //                   <path d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z" fill="currentColor"></path>
// //                 </svg>
// //               </div>
// //             </div>
// //           </div>

// //           <div className="swiper overflow-hidden" data-swiper="geners-slider">
// //             <Slider ref={sliderRef} {...sliderSettings}>
// //               {genres.map((genre) => (
// //                 <div key={genre._id} className="swiper-slide mb-3">
// //                   <Link
// //                     to={`/party-music/${genre._id}`}
// //                     className="text-capitalize line-count-1 h5 d-block"
// //                   >
// //                     <img
// //                       src={genre.themeImageUrl || `${process.env.PUBLIC_URL}/img/covers/cover.svg`}
// //                       id={genre._id}
// //                       className="mb-3 img-fluid rounded-3"
// //                       alt="song-img"
// //                     />
// //                     {genre.name}
// //                   </Link>
// //                   <small className="fw-normal text-capitalize line-count-1">
// //                     {genre.description}
// //                   </small>
// //                 </div>
// //               ))}
// //             </Slider>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Share Popup */}
// //       {sharePopup.open && sharePopup.song && (
// //         <div className="modal-overlay" style={{
// //           position: 'fixed',
// //           top: 0,
// //           left: 0,
// //           right: 0,
// //           bottom: 0,
// //           backgroundColor: 'rgba(0, 0, 0, 0.8)',
// //           display: 'flex',
// //           alignItems: 'center',
// //           justifyContent: 'center',
// //           zIndex: 9999
// //         }}>
// //           <div className="share-popup" style={{
// //             backgroundColor: '#1a1a1a',
// //             padding: '25px',
// //             borderRadius: '12px',
// //             width: '90%',
// //             maxWidth: '350px',
// //             color: 'white',
// //             border: '1px solid #333',
// //             boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
// //           }}>
// //             <div style={{
// //               textAlign: 'center',
// //               marginBottom: '25px'
// //             }}>
// //               <h4 style={{
// //                 margin: '0 0 10px 0',
// //                 fontSize: '18px',
// //                 fontWeight: '600'
// //               }}>
// //                 Share
// //               </h4>
// //               <p style={{
// //                 margin: 0,
// //                 color: '#ccc',
// //                 fontSize: '14px'
// //               }}>
// //                 {sharePopup.song.title}
// //               </p>
// //             </div>

// //             <div style={{
// //               display: 'flex',
// //               justifyContent: 'center',
// //               gap: '20px',
// //               marginBottom: '25px'
// //             }}>
// //               <button
// //                 onClick={() => shareOnSocialMedia('facebook', sharePopup.song)}
// //                 style={{
// //                   background: 'none',
// //                   border: 'none',
// //                   color: '#1877f2',
// //                   cursor: 'pointer',
// //                   display: 'flex',
// //                   flexDirection: 'column',
// //                   alignItems: 'center',
// //                   gap: '8px',
// //                   fontSize: '12px'
// //                 }}
// //               >
// //                 <div style={{
// //                   width: '50px',
// //                   height: '50px',
// //                   backgroundColor: '#1877f2',
// //                   borderRadius: '50%',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   fontSize: '20px'
// //                 }}>
// //                   <i className="fab fa-facebook-f" style={{ color: 'white' }}></i>
// //                 </div>
// //                 Facebook
// //               </button>

// //               <button
// //                 onClick={() => shareOnSocialMedia('twitter', sharePopup.song)}
// //                 style={{
// //                   background: 'none',
// //                   border: 'none',
// //                   color: '#1da1f2',
// //                   cursor: 'pointer',
// //                   display: 'flex',
// //                   flexDirection: 'column',
// //                   alignItems: 'center',
// //                   gap: '8px',
// //                   fontSize: '12px'
// //                 }}
// //               >
// //                 <div style={{
// //                   width: '50px',
// //                   height: '50px',
// //                   backgroundColor: '#1da1f2',
// //                   borderRadius: '50%',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   fontSize: '20px'
// //                 }}>
// //                   <i className="fab fa-twitter" style={{ color: 'white' }}></i>
// //                 </div>
// //                 Twitter
// //               </button>

// //               <button
// //                 onClick={() => shareOnSocialMedia('whatsapp', sharePopup.song)}
// //                 style={{
// //                   background: 'none',
// //                   border: 'none',
// //                   color: '#25d366',
// //                   cursor: 'pointer',
// //                   display: 'flex',
// //                   flexDirection: 'column',
// //                   alignItems: 'center',
// //                   gap: '8px',
// //                   fontSize: '12px'
// //                 }}
// //               >
// //                 <div style={{
// //                   width: '50px',
// //                   height: '50px',
// //                   backgroundColor: '#25d366',
// //                   borderRadius: '50%',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   fontSize: '20px'
// //                 }}>
// //                   <i className="fab fa-whatsapp" style={{ color: 'white' }}></i>
// //                 </div>
// //                 Whatsapp
// //               </button>

// //               <button
// //                 onClick={() => shareOnSocialMedia('telegram', sharePopup.song)}
// //                 style={{
// //                   background: 'none',
// //                   border: 'none',
// //                   color: '#0088cc',
// //                   cursor: 'pointer',
// //                   display: 'flex',
// //                   flexDirection: 'column',
// //                   alignItems: 'center',
// //                   gap: '8px',
// //                   fontSize: '12px'
// //                 }}
// //               >
// //                 <div style={{
// //                   width: '50px',
// //                   height: '50px',
// //                   backgroundColor: '#0088cc',
// //                   borderRadius: '50%',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   fontSize: '20px'
// //                 }}>
// //                   <i className="fab fa-telegram" style={{ color: 'white' }}></i>
// //                 </div>
// //                 Telegram
// //               </button>
// //             </div>

// //             <div style={{
// //               display: 'flex',
// //               gap: '10px',
// //               alignItems: 'center'
// //             }}>
// //               <input
// //                 type="text"
// //                 value={generateShareableUrl(sharePopup.song._id)}
// //                 readOnly
// //                 style={{
// //                   flex: 1,
// //                   padding: '12px 15px',
// //                   backgroundColor: '#2a2a2a',
// //                   border: '1px solid #444',
// //                   borderRadius: '8px',
// //                   color: 'white',
// //                   fontSize: '14px'
// //                 }}
// //               />
// //               <button
// //                 onClick={handleCopy}
// //                 style={{
// //                   padding: '12px 20px',
// //                   backgroundColor: '#1DB954',
// //                   color: 'white',
// //                   border: 'none',
// //                   borderRadius: '8px',
// //                   cursor: 'pointer',
// //                   fontSize: '14px',
// //                   fontWeight: '600'
// //                 }}
// //               >
// //                 COPY
// //               </button>
// //             </div>

// //             <button
// //               onClick={closeSharePopup}
// //               style={{
// //                 width: '100%',
// //                 marginTop: '20px',
// //                 padding: '12px',
// //                 backgroundColor: 'transparent',
// //                 color: '#ccc',
// //                 border: '1px solid #444',
// //                 borderRadius: '8px',
// //                 cursor: 'pointer',
// //                 fontSize: '14px'
// //               }}
// //             >
// //               CANCEL
// //             </button>
// //           </div>
// //         </div>
// //       )}

// //       {/* Playlist Modal */}
// //       {playlistModal.open && playlistModal.song && (
// //         <div
// //           className="modal-overlay"
// //           style={{
// //             position: "fixed",
// //             top: 0,
// //             left: 0,
// //             right: 0,
// //             bottom: 0,
// //             backgroundColor: "rgba(0, 0, 0, 0.8)",
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             zIndex: 9999,
// //           }}
// //         >
// //           <div
// //             className="playlist-popup"
// //             style={{
// //               backgroundColor: "#1a1a1a",
// //               padding: "25px",
// //               borderRadius: "12px",
// //               width: "90%",
// //               maxWidth: "400px",
// //               color: "white",
// //               border: "1px solid #333",
// //               boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
// //             }}
// //           >
// //             <div
// //               style={{
// //                 textAlign: "center",
// //                 marginBottom: "20px",
// //               }}
// //             >
// //               <h4
// //                 style={{
// //                   margin: "0 0 10px 0",
// //                   fontSize: "18px",
// //                   fontWeight: "600",
// //                   color: "#ffff",
// //                 }}
// //               >
// //                 Add to Playlist
// //               </h4>
// //               <p
// //                 style={{
// //                   margin: 0,
// //                   color: "#ccc",
// //                   fontSize: "14px",
// //                 }}
// //               >
// //                 {playlistModal.song.title}
// //               </p>
// //             </div>

// //             {!showCreateForm ? (
// //               <>
// //                 <div
// //                   style={{
// //                     maxHeight: "200px",
// //                     overflowY: "auto",
// //                     marginBottom: "20px",
// //                   }}
// //                 >
// //                   {playlists.length > 0 ? (
// //                     playlists.map((playlist) => (
// //                       <div
// //                         key={playlist._id}
// //                         style={{
// //                           padding: "12px",
// //                           border: "1px solid #333",
// //                           borderRadius: "8px",
// //                           marginBottom: "8px",
// //                           cursor: "pointer",
// //                           display: "flex",
// //                           alignItems: "center",
// //                           gap: "10px",
// //                         }}
// //                         onClick={() =>
// //                           addToPlaylist(playlist._id, playlistModal.song._id)
// //                         }
// //                       >
// //                         <img
// //                           src={
// //                             playlist.playlistCoverUrl || "img/covers/cover.svg"
// //                           }
// //                           alt={playlist.name}
// //                           style={{
// //                             width: "40px",
// //                             height: "40px",
// //                             borderRadius: "4px",
// //                             objectFit: "cover",
// //                           }}
// //                         />
// //                         <div>
// //                           <div style={{ fontWeight: "500" }}>
// //                             {playlist.name}
// //                           </div>
// //                           {playlist.description && (
// //                             <div style={{ fontSize: "12px", color: "#ccc" }}>
// //                               {playlist.description}
// //                             </div>
// //                           )}
// //                         </div>
// //                       </div>
// //                     ))
// //                   ) : (
// //                     <div
// //                       style={{
// //                         textAlign: "center",
// //                         padding: "20px",
// //                         color: "#ccc",
// //                       }}
// //                     >
// //                       No playlists found
// //                     </div>
// //                   )}
// //                 </div>

// //                 <button
// //                   onClick={() => setShowCreateForm(true)}
// //                   style={{
// //                     width: "100%",
// //                     padding: "12px",
// //                     backgroundColor: "#1DB954",
// //                     color: "white",
// //                     border: "none",
// //                     borderRadius: "8px",
// //                     cursor: "pointer",
// //                     fontSize: "14px",
// //                     fontWeight: "600",
// //                     marginBottom: "10px",
// //                   }}
// //                 >
// //                   Create New Playlist
// //                 </button>
// //               </>
// //             ) : (
// //               <div>
// //                 <div style={{ marginBottom: "15px" }}>
// //                   <label
// //                     style={{
// //                       display: "block",
// //                       marginBottom: "5px",
// //                       fontSize: "14px",
// //                     }}
// //                   >
// //                     Playlist Name *
// //                   </label>
// //                   <input
// //                     type="text"
// //                     value={newPlaylist.name}
// //                     onChange={(e) =>
// //                       setNewPlaylist((prev) => ({
// //                         ...prev,
// //                         name: e.target.value,
// //                       }))
// //                     }
// //                     placeholder="Enter playlist name"
// //                     style={{
// //                       width: "100%",
// //                       padding: "10px",
// //                       backgroundColor: "#2a2a2a",
// //                       border: "1px solid #444",
// //                       borderRadius: "6px",
// //                       color: "white",
// //                       fontSize: "14px",
// //                     }}
// //                   />
// //                 </div>

// //                 <div style={{ marginBottom: "15px" }}>
// //                   <label
// //                     style={{
// //                       display: "block",
// //                       marginBottom: "5px",
// //                       fontSize: "14px",
// //                     }}
// //                   >
// //                     Description
// //                   </label>
// //                   <textarea
// //                     value={newPlaylist.description}
// //                     onChange={(e) =>
// //                       setNewPlaylist((prev) => ({
// //                         ...prev,
// //                         description: e.target.value,
// //                       }))
// //                     }
// //                     placeholder="Enter playlist description"
// //                     rows="3"
// //                     style={{
// //                       width: "100%",
// //                       padding: "10px",
// //                       backgroundColor: "#2a2a2a",
// //                       border: "1px solid #444",
// //                       borderRadius: "6px",
// //                       color: "white",
// //                       fontSize: "14px",
// //                       resize: "vertical",
// //                     }}
// //                   />
// //                 </div>

// //                 <div style={{ marginBottom: "20px" }}>
// //                   <label
// //                     style={{
// //                       display: "block",
// //                       marginBottom: "5px",
// //                       fontSize: "14px",
// //                     }}
// //                   >
// //                     Cover Image
// //                   </label>
// //                   <input
// //                     type="file"
// //                     accept="image/*"
// //                     onChange={handleFileChange}
// //                     style={{
// //                       width: "100%",
// //                       padding: "8px",
// //                       backgroundColor: "#2a2a2a",
// //                       border: "1px solid #444",
// //                       borderRadius: "6px",
// //                       color: "white",
// //                       fontSize: "14px",
// //                     }}
// //                   />
// //                 </div>

// //                 <div style={{ display: "flex", gap: "10px" }}>
// //                   <button
// //                     onClick={createNewPlaylist}
// //                     disabled={playlistLoading}
// //                     style={{
// //                       flex: 1,
// //                       padding: "12px",
// //                       backgroundColor: "#1DB954",
// //                       color: "white",
// //                       border: "none",
// //                       borderRadius: "8px",
// //                       cursor: playlistLoading ? "not-allowed" : "pointer",
// //                       fontSize: "14px",
// //                       fontWeight: "600",
// //                       opacity: playlistLoading ? 0.7 : 1,
// //                     }}
// //                   >
// //                     {playlistLoading ? "Creating..." : "Create Playlist"}
// //                   </button>
// //                   <button
// //                     onClick={() => setShowCreateForm(false)}
// //                     style={{
// //                       flex: 1,
// //                       padding: "12px",
// //                       backgroundColor: "transparent",
// //                       color: "#ccc",
// //                       border: "1px solid #444",
// //                       borderRadius: "8px",
// //                       cursor: "pointer",
// //                       fontSize: "14px",
// //                     }}
// //                   >
// //                     Cancel
// //                   </button>
// //                 </div>
// //               </div>
// //             )}

// //             {!showCreateForm && (
// //               <button
// //                 onClick={closePlaylistModal}
// //                 style={{
// //                   width: "100%",
// //                   marginTop: "10px",
// //                   padding: "12px",
// //                   backgroundColor: "transparent",
// //                   color: "#ccc",
// //                   border: "1px solid #444",
// //                   borderRadius: "8px",
// //                   cursor: "pointer",
// //                   fontSize: "14px",
// //                 }}
// //               >
// //                 CLOSE
// //               </button>
// //             )}
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// // export default AdminPlaylist;

// import React, { useState, useEffect, useRef } from "react";
// import { Link, useParams, useNavigate } from "react-router-dom";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import httpClient from "../../utils/httpClients";
// import { usePlayer } from "../../../PlayerContext";

// function AdminPlaylist() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const sliderRef = useRef(null);

//   const [musics, setMusics] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [likedSongs, setLikedSongs] = useState(new Set());
//   const [sharePopup, setSharePopup] = useState({ open: false, song: null });
//   const [playCountTracked, setPlayCountTracked] = useState(false);
//   const playTimerRef = useRef(null);
//   const [genres, setGenres] = useState([]);
//   const [genreLoading, setGenreLoading] = useState(null);

//   const [playlistModal, setPlaylistModal] = useState({ open: false, song: null });
//   const [playlists, setPlaylists] = useState([]);
//   const [newPlaylist, setNewPlaylist] = useState({ name: "", description: "", coverImage: null });
//   const [showCreateForm, setShowCreateForm] = useState(false);
//   const [playlistLoading, setPlaylistLoading] = useState(false);

//   const {
//     isPlaying,
//     currentTrack,
//     togglePlayPause,
//     seek,
//     duration,
//     triggerQueueUpdate,
//     tracks,
//   } = usePlayer();

//   // === QUEUE ACTION - EXACTLY AS YOU WANTED ===
//   const handleQueueAction = async (action, trackId = null, playlistId = null, type = null) => {
//     try {
//       const payload = { action };

//       if (action === "addAllToQueue") {
//         payload.playlistId = playlistId || id;  // same parentId
//         payload.type = type;                    // "like" | "playlist" | "genresong"
//       } else if (action === "add" || action === "addAndPlay") {
//         payload.trackId = trackId;
//       }

//       const res = await httpClient.post("user/queue/queue-controller", payload);
//       if (res.data?.success) {
//         triggerQueueUpdate();
//         return true;
//       }
//       return false;
//     } catch (err) {
//       console.error("Queue error:", err);
//       return false;
//     }
//   };

//   // === PLAY SINGLE SONG ===
//   const playNow = async (trackId) => {
//     if (currentTrack?._id === trackId) {
//       togglePlayPause();
//       return;
//     }
//     const success = await handleQueueAction("addAndPlay", trackId);
//     if (success && !isPlaying) togglePlayPause();
//   };

//   // === PLAY ALL → addAllToQueue with same parentId + type: "like" ===
//   const playAllSongs = async () => {
//     if (musics.length === 0) return;

//     const isFromThisSource = currentTrack && musics.some(m => m._id === currentTrack._id);

//     if (!currentTrack || !isFromThisSource) {
//       const type = window.location.pathname.includes("/like") ? "like" : "playlist";
//       const success = await handleQueueAction("addAllToQueue", null, id, type);
//       if (success && !isPlaying) togglePlayPause();
//     } else {
//       togglePlayPause();
//     }
//   };

//   // === GENRE CLICK ===
//   const playGenreSongs = async (genreId) => {
//     setGenreLoading(genreId);
//     try {
//       const success = await handleQueueAction("addAllToQueue", null, genreId, "genresong");
//       if (success) {
//         navigate(`/party-music/${genreId}`);
//         if (!isPlaying) togglePlayPause();
//       }
//     } catch (err) {
//       alert("Failed to load genre");
//     } finally {
//       setGenreLoading(null);
//     }
//   };

//   // === FETCH DATA ===
//   const fetchGenresSongs = async () => {
//     try {
//       const res = await httpClient.get(`/user/music/get-themes`);
//       if (res.data?.success) setGenres(res.data.data.getThemes || []);
//     } catch (err) { console.error(err); }
//   };

//   const fetchPlayMusics = async () => {
//     try {
//       setLoading(true);
//       const res = await httpClient.get(`user/music/get-admin-playlist-songs/${id}`);
//       if (res.data?.success) {
//         const data = res.data.data?.songs || [];
//         setMusics(data);
//         const liked = new Set(data.filter(m => m.isLiked).map(m => m._id));
//         setLikedSongs(liked);
//       }
//     } catch (err) {
//       setError("Failed to load");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLikeSong = async (id, isLiked) => {
//     try {
//       const action = isLiked ? "dislike" : "like";
//       const res = await httpClient.post(`/user/play-history/like-content/${id}/${action}`);
//       if (res.data?.success) {
//         setLikedSongs(prev => {
//           const s = new Set(prev);
//           isLiked ? s.delete(id) : s.add(id);
//           return s;
//         });
//         setMusics(prev => prev.map(m => m._id === id ? { ...m, isLiked: !isLiked } : m));
//       }
//     } catch (err) { console.error(err); }
//   };

//   // === PLAY COUNT ===
//   useEffect(() => {
//     if (currentTrack && isPlaying) {
//       playTimerRef.current = setTimeout(() => {
//         httpClient.post(`user/play-history/content-play-count/${currentTrack._id}`);
//         setPlayCountTracked(true);
//       }, 10000);
//     } else {
//       clearTimeout(playTimerRef.current);
//     }
//     return () => clearTimeout(playTimerRef.current);
//   }, [isPlaying, currentTrack]);

//   // === UTILS ===
//   const formatDuration = (seconds) => {
//         if (!seconds || isNaN(seconds)) return "0:00";
//         const mins = Math.floor(seconds / 60);
//         const secs = Math.floor(seconds % 60);
//         return `${mins}:${secs.toString().padStart(2, "0")}`;
//       };

//       const generateShareableUrl = (id) => `https://webmobrildemo.com/volumetv/music/${encodeURIComponent(id)}`;

//   const handleCopy = async () => {
//     const text = generateShareableUrl(sharePopup.song._id);
//     try { await navigator.clipboard.writeText(text); }
//     catch { const ta = document.createElement("textarea"); ta.value = text; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); document.body.removeChild(ta); }
//   };

//   const shareOnSocialMedia = (platform, song) => {
//     const url = generateShareableUrl(song._id);
//     const text = encodeURIComponent(song.title);
//     const links = {
//       facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
//       twitter: `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
//       whatsapp: `https://api.whatsapp.com/send?text=${text}%20${url}`,
//       telegram: `https://t.me/share/url?url=${url}&text=${text}`,
//     };
//     window.open(links[platform], "_blank");
//   };

//   // === PLAYLIST MODAL ===
//   const fetchPlaylists = async () => {
//     try {
//       const res = await httpClient.get("/user/playlist/get-playlists");
//       if (res.data?.success) setPlaylists(res.data.data.playlist || []);
//     } catch (err) { console.error(err); }
//   };

//   const openPlaylistModal = (song, e) => {
//     e.preventDefault(); e.stopPropagation();
//     setPlaylistModal({ open: true, song });
//     fetchPlaylists();
//     setOpenDropdown(null);
//   };

//   const closePlaylistModal = () => {
//     setPlaylistModal({ open: false, song: null });
//     setShowCreateForm(false);
//     setNewPlaylist({ name: "", description: "", coverImage: null });
//   };

//   const createNewPlaylist = async () => {
//     if (!newPlaylist.name.trim()) return alert("Enter name");
//     try {
//       setPlaylistLoading(true);
//       const fd = new FormData();
//       fd.append("name", newPlaylist.name);
//       fd.append("description", newPlaylist.description);
//       if (newPlaylist.coverImage) fd.append("coverImage", newPlaylist.coverImage);

//       const res = await httpClient.post("/user/playlist/create-playlist", fd, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (res.data?.success) {
//         await fetchPlaylists();
//         setShowCreateForm(false);
//         setNewPlaylist({ name: "", description: "", coverImage: null });
//         if (playlistModal.song) await addToPlaylist(res.data.data.playlist._id, playlistModal.song._id);
//       }
//     } catch (err) { alert("Failed"); } finally { setPlaylistLoading(false); }
//   };

//   const addToPlaylist = async (playlistId, songId) => {
//     try {
//       const params = new URLSearchParams({ playlistId, itemId: songId, itemType: "Music" });
//       const res = await httpClient.post(`/user/playlist/add-item?${params}`);
//       if (res.data?.success) {
//         closePlaylistModal();
//       }
//     } catch (err) { console.error(err); }
//   };

//   const handleFileChange = (e) => {
//     if (e.target.files[0]) setNewPlaylist(prev => ({ ...prev, coverImage: e.target.files[0] }));
//   };

//   // === OUTSIDE CLICK ===
//   useEffect(() => {
//     const handler = (e) => {
//       if (!e.target.closest(".dropdown")) setOpenDropdown(null);
//       if (!e.target.closest(".share-popup") && !e.target.closest(".single-item__export")) setSharePopup({ open: false, song: null });
//       if (!e.target.closest(".playlist-popup") && !e.target.closest(".dropdown-item")) closePlaylistModal();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   useEffect(() => { window.scrollTo(0, 0); }, []);
//   useEffect(() => { fetchGenresSongs(); }, []);
//   useEffect(() => { if (id) fetchPlayMusics(); }, [id]);

//   const sliderSettings = {
//     dots: false, infinite: true, speed: 500, slidesToShow: 6, slidesToScroll: 3, arrows: false,
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 4 } },
//       { breakpoint: 768, settings: { slidesToShow: 3 } },
//       { breakpoint: 480, settings: { slidesToShow: 2 } },
//     ],
//   };

//   if (loading) return <div className="content-inner pb-0 container-fluid"><div className="d-flex justify-content-center align-items-center" style={{height:"50vh"}}><div className="spinner-border text-primary"></div></div></div>;
//   if (error) return <div className="content-inner pb-0 container-fluid"><div className="alert alert-danger">{error}</div></div>;

//   return (
//     <div className="content-inner pb-0 container-fluid" id="page_layout">
//       <div className="row row--grid">
//         {/* Breadcrumb */}
//         <div className="col-12">
//           <ul className="breadcrumb">
//             <li className="breadcrumb__item"><Link to="/">Home</Link></li>
//             <li className="breadcrumb__item breadcrumb__item--active">Play List Music</li>
//           </ul>
//         </div>
//         <div className="col-12"><div className="main__title main__title--page"><h1>Playlist Music</h1></div></div>

//         {/* Main Content */}
//         <div className="col-12">
//           <div className="release">
//             <div className="release__content">
//               <div className="release__cover">
//                 <img src={`${process.env.PUBLIC_URL}/img/covers/cover3.jpg`} alt="cover" />
//               </div>
//               <div className="release__stat">
//                 <span>{musics.length} tracks</span>
//                 <span>{currentTrack?.playCount || 0}</span>
//               </div>
//               <div className="d-flex justify-content-between gap-3">
//                 <a className="release__buy open-modal" onClick={playAllSongs} style={{cursor:"pointer"}}>
//                   <i className={isPlaying ? "fas fa-pause" : "fas fa-play"}></i>
//                   {isPlaying ? "Pause" : "Play All"}
//                 </a>
//               </div>
//             </div>

//             <div className="release__list">
//               <ul className="main__list main__list--playlist main__list--dashbox">
//                 <h4 className="card-title text-capitalize episodes">All Tracks</h4>
//                 {musics.map((music, i) => {
//                   const isNow = currentTrack?._id === music._id;
//                   const isLiked = likedSongs.has(music._id);
//                   const queuePos = tracks.findIndex(t => t._id === music._id) + 1 || null;

//                   return (
//                     <li key={music._id} className={`single-item list-1 ${isNow ? "active-episode" : ""}`}
//                       style={{backgroundColor: isNow ? "rgba(255,255,255,0.1)" : "", borderLeft: isNow ? "3px solid #1DB954" : ""}}>
//                       <div className="single-item__cover" onClick={() => playNow(music._id)} style={{cursor:"pointer"}}>
//                         <img src={music.coverImageUrl || `${process.env.PUBLIC_URL}/img/covers/cover.svg`} alt={music.title} />
//                         {isNow && isPlaying ? (
//                           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{fill:"#1DB954"}}><path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z"/></svg>
//                         ) : (
//                           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{fill: isNow ? "#1DB954" : "#fff"}}><path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z"/></svg>
//                         )}
//                       </div>

//                       <div className="single-item__title">
//                         <h4 onClick={() => music.isAlbum && navigate(`/album/${music.parentId}`)} style={{cursor: music.isAlbum ? "pointer" : "default"}}>
//                           {i + 1}. {music.title}
//                           {isNow && <span className="badge bg-success ms-2" style={{fontSize:"0.7em"}}>Playing</span>}
//                           {queuePos && !isNow && <span className="badge bg-info ms-2" style={{fontSize:"0.7em"}}>#{queuePos}</span>}
//                         </h4>
//                         <span onClick={() => music.artistIds?.[0] && navigate(`/art/${music.artistIds[0]}`)} style={{cursor: music.artistIds?.[0] ? "pointer" : "default", color:"#1DB954"}}>
//                           {music.artist || "Unknown"}
//                         </span>
//                       </div>

//          <div className="dropdown">
//                           <span className={`d-flex text-white align-items-center h5 mb-0 ${isDropdownOpen ? "show" : ""}`} onClick={() => toggleDropdown(contentId)}>
//                    <i className="fas fa-ellipsis-h"></i>
//                           </span>
//                           <div className={`dropdown-menu dropdown-menu-end ${isDropdownOpen ? "show" : ""}`} style={isDropdownOpen ? { position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate(0px, 19px)" } : {}}>
//                             <a className="dropdown-item" href="#!" onClick={(e) => openPlaylistModal(song, e)}>
//                               <span className="material-icons">library_music</span> Add To Playlist
//                             </a>

//                             <a className="dropdown-item" href="#!" onClick={(e) => { e.preventDefault(); addToQueue(contentId); setOpenDropdown(null); }}>
//                                  <span className="material-icons">playlist_add</span> Add To Queue
//                             </a>

//                             <a className={`dropdown-item ${!ArtistId ? "disabled" : ""}`} href="#!" onClick={(e) => { e.preventDefault(); if (ArtistId) { sendToArtist(ArtistId); setOpenDropdown(null); } }}>
//                               <span className="material-icons">music_note</span> Go To Artist
//                             </a>

//                             <a className={`dropdown-item ${!isAlbhum ? "disabled" : ""}`} href="#!" onClick={(e) => { e.preventDefault(); if (isAlbhum) { sendToAlbum(AlbhumId, isAlbhum); setOpenDropdown(null); } }}>
//                                <span className="material-icons">album</span> Go To Album
//                             </a>
//                           </div>
//                         </div>

//                       <a href="#!" className={`single-item__add ${isLiked ? "liked" : ""}`} onClick={(e) => { e.preventDefault(); handleLikeSong(music._id, isLiked); }}>
//                         <i className={isLiked ? "fas fa-heart" : "far fa-heart"}></i>
//                       </a>

//                       <a href="#!" className="single-item__export" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSharePopup({ open: true, song: music }); }}>
//                         <i className="fas fa-share"></i>
//                       </a>

//                       <span className="single-item__time">
//                         {isNow ? `${formatDuration(seek)} / ${formatDuration(duration)}` : formatDuration(music.duration)}
//                       </span>
//                     </li>
//                   );
//                 })}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* GENRES */}
//       <div className="row">
//         <div className="col-lg-12 mb-5">
//           <div className="card-header mb-3">
//             <div className="header-title"><h4 className="card-title text-capitalize">top song genres for you</h4></div>
//             <div className="common-album position-relative d-lg-block d-none">
//               <div className="swiper-button-prev" onClick={() => sliderRef.current?.slickPrev()} style={{cursor:"pointer"}}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none"><path d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z" fill="#4A525F"></path></svg></div>
//               <div className="swiper-button-next" onClick={() => sliderRef.current?.slickNext()} style={{cursor:"pointer"}}><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none"><path d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z" fill="currentColor"></path></svg></div>
//             </div>
//           </div>
//           <div className="swiper overflow-hidden">
//             <Slider ref={sliderRef} {...sliderSettings}>
//               {genres.map(g => (
//                 <div key={g._id} className="swiper-slide mb-3">
//                   <div onClick={() => playGenreSongs(g._id)} style={{cursor:"pointer"}} className="text-capitalize line-count-1 h5 d-block">
//                     <img src={g.themeImageUrl} className="mb-3 img-fluid rounded-3" alt={g.name} />
//                     {genreLoading === g._id ? "Loading..." : g.name}
//                   </div>
//                   <small className="fw-normal text-capitalize line-count-1">{g.description}</small>
//                 </div>
//               ))}
//             </Slider>
//           </div>
//         </div>
//       </div>

//       {/* SHARE POPUP */}
//       {sharePopup.open && sharePopup.song && (
//         <div className="modal-overlay" style={{position:'fixed',top:0,left:0,right:0,bottom:0,backgroundColor:'rgba(0,0,0,0.8)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
//           <div className="share-popup" style={{backgroundColor:'#1a1a1a',padding:'25px',borderRadius:'12px',width:'90%',maxWidth:'350px',color:'white',border:'1px solid #333',boxShadow:'0 10px 30px rgba(0,0,0,0.5)'}}>
//             <div style={{textAlign:'center',marginBottom:'25px'}}><h4 style={{margin:'0 0 10px',fontSize:'18px',fontWeight:'600'}}>Share</h4><p style={{margin:0,color:'#ccc',fontSize:'14px'}}>{sharePopup.song.title}</p></div>
//             <div style={{display:'flex',justifyContent:'center',gap:'20px',marginBottom:'25px'}}>
//               {['facebook','twitter','whatsapp','telegram'].map(p=>(
//                 <button key={p} onClick={()=>shareOnSocialMedia(p,sharePopup.song)} style={{background:'none',border:'none',cursor:'pointer'}}>
//                   <div style={{width:'50px',height:'50px',backgroundColor:p==='facebook'?'#1877f2':p==='twitter'?'#1da1f2':p==='whatsapp'?'#25d366':'#0088cc',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center'}}>
//                     <i className={`fab fa-${p==='twitter'?'x-twitter':p}`} style={{color:'white',fontSize:'20px'}}></i>
//                   </div>
//                   <span style={{display:'block',fontSize:'12px',marginTop:'8px'}}>{p.charAt(0).toUpperCase()+p.slice(1)}</span>
//                 </button>
//               ))}
//             </div>
//             <div style={{display:'flex',gap:'10px'}}>
//               <input type="text" value={generateShareableUrl(sharePopup.song._id)} readOnly style={{flex:1,padding:'12px',background:'#2a2a2a',border:'1px solid #444',borderRadius:'8px',color:'white'}} />
//               <button onClick={handleCopy} style={{padding:'12px 20px',background:'#1DB954',color:'white',border:'none',borderRadius:'8px',cursor:'pointer'}}>COPY</button>
//             </div>
//             <button onClick={()=>setSharePopup({open:false,song:null})} style={{width:'100%',marginTop:'20px',padding:'12px',background:'transparent',color:'#ccc',border:'1px solid #444',borderRadius:'8px',cursor:'pointer'}}>CANCEL</button>
//           </div>
//         </div>
//       )}

//       {/* PLAYLIST MODAL */}
//       {playlistModal.open && playlistModal.song && (
//         <div className="modal-overlay" style={{position:"fixed",top:0,left:0,right:0,bottom:0,backgroundColor:"rgba(0,0,0,0.8)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999}}>
//           <div className="playlist-popup" style={{backgroundColor:"#1a1a1a",padding:"25px",borderRadius:"12px",width:"90%",maxWidth:"400px",color:"white",border:"1px solid #333",boxShadow:"0 10px 30px rgba(0,0,0,0.5)"}}>
//             <div style={{textAlign:"center",marginBottom:"20px"}}><h4 style={{margin:"0 0 10px",fontSize:"18px",fontWeight:"600"}}>Add to Playlist</h4><p style={{margin:0,color:"#ccc",fontSize:"14px"}}>{playlistModal.song.title}</p></div>
//             {!showCreateForm ? (
//               <>
//                 <div style={{maxHeight:"200px",overflowY:"auto",marginBottom:"20px"}}>
//                   {playlists.length > 0 ? playlists.map(pl => (
//                     <div key={pl._id} style={{padding:"12px",border:"1px solid #333",borderRadius:"8px",marginBottom:"8px",cursor:"pointer",display:"flex",alignItems:"center",gap:"10px"}}
//                       onClick={() => addToPlaylist(pl._id, playlistModal.song._id)}>
//                       <img src={pl.playlistCoverUrl || "img/covers/cover.svg"} alt={pl.name} style={{width:"40px",height:"40px",borderRadius:"4px",objectFit:"cover"}} />
//                       <div><div style={{fontWeight:"500"}}>{pl.name}</div>{pl.description && <div style={{fontSize:"12px",color:"#ccc"}}>{pl.description}</div>}</div>
//                     </div>
//                   )) : <div style={{textAlign:"center",padding:"20px",color:"#ccc"}}>No playlists found</div>}
//                 </div>
//                 <button onClick={() => setShowCreateForm(true)} style={{width:"100%",padding:"12px",backgroundColor:"#1DB954",color:"white",border:"none",borderRadius:"8px",cursor:"pointer",marginBottom:"10px"}}>Create New Playlist</button>
//                 <button onClick={closePlaylistModal} style={{width:"100%",padding:"12px",background:"transparent",color:"#ccc",border:"1px solid #444",borderRadius:"8px",cursor:"pointer"}}>CLOSE</button>
//               </>
//             ) : (
//               <div>
//                 <div style={{marginBottom:"15px"}}><label style={{display:"block",marginBottom:"5px"}}>Playlist Name *</label><input type="text" value={newPlaylist.name} onChange={e=>setNewPlaylist(p=>({...p,name:e.target.value}))} placeholder="Enter name" style={{width:"100%",padding:"10px",background:"#2a2a2a",border:"1px solid #444",borderRadius:"6px",color:"white"}} /></div>
//                 <div style={{marginBottom:"15px"}}><label style={{display:"block",marginBottom:"5px"}}>Description</label><textarea value={newPlaylist.description} onChange={e=>setNewPlaylist(p=>({...p,description:e.target.value}))} rows="3" style={{width:"100%",padding:"10px",background:"#2a2a2a",border:"1px solid #444",borderRadius:"6px",color:"white",resize:"vertical"}} /></div>
//                 <div style={{marginBottom:"20px"}}><label style={{display:"block",marginBottom:"5px"}}>Cover Image</label><input type="file" accept="image/*" onChange={handleFileChange} style={{width:"100%",padding:"8px",background:"#2a2a2a",border:"1px solid #444",borderRadius:"6px",color:"white"}} /></div>
//                 <div style={{display:"flex",gap:"10px"}}>
//                   <button onClick={createNewPlaylist} disabled={playlistLoading} style={{flex:1,padding:"12px",background:"#1DB954",color:"white",border:"none",borderRadius:"8px",cursor:playlistLoading?"not-allowed":"pointer",opacity:playlistLoading?0.7:1}}>
//                     {playlistLoading ? "Creating..." : "Create"}
//                   </button>
//                   <button onClick={() => setShowCreateForm(false)} style={{flex:1,padding:"12px",background:"transparent",color:"#ccc",border:"1px solid #444",borderRadius:"8px",cursor:"pointer"}}>Cancel</button>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default AdminPlaylist;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import httpClient from "../../utils/httpClients";
import { usePlayer } from "../../../PlayerContext";

function AdminPlaylist() {
  const { id } = useParams();
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  const [musics, setMusics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [likedSongs, setLikedSongs] = useState(new Set());
  const [sharePopup, setSharePopup] = useState({ open: false, song: null });
  const [lastPlayedCountTrackedSongId, setLastPlayedCountTrackedSongId] =
    useState(null);
  const playTimerRef = useRef(null);
  const [genres, setGenres] = useState([]);
  const [genreLoading, setGenreLoading] = useState(null);
  const [playlistInfo, setPlaylistInfo] = useState({ name: "" });

  // Playlist Modal
  const [playlistModal, setPlaylistModal] = useState({
    open: false,
    song: null,
  });
  const [playlists, setPlaylists] = useState([]);
  const [newPlaylist, setNewPlaylist] = useState({
    name: "",
    description: "",
    coverImage: null,
  });
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [playlistLoading, setPlaylistLoading] = useState(false);

  const {
    isPlaying,
    currentTrack,
    togglePlayPause,
    seek,
    duration,
    triggerQueueUpdate,
    tracks,
    playTrackById,
    stopPlayback,
  } = usePlayer();

  // === LOCAL PAGE PLAYBACK STATE ===
  const [selectedSongId, setSelectedSongId] = useState(null);
  const [hasInitiatedPlayback, setHasInitiatedPlayback] = useState(false);

  // Reset selection / playback init flag when playlist id changes
  useEffect(() => {
    setSelectedSongId(null);
    setHasInitiatedPlayback(false);
    setMusics([]);
    setLoading(true);
    setError(null);
  }, [id]);

  // Auto-pick first song as default once musics arrive
  useEffect(() => {
    if (!selectedSongId && musics.length > 0) {
      setSelectedSongId(musics[0]._id);
    }
  }, [musics, selectedSongId]);

  const selectedSong =
    musics.find((song) => song._id === selectedSongId) || null;

  const displayTrack =
    selectedSong || (musics.length > 0 ? musics[0] : null);

  const isDisplayTrackPlaying =
    hasInitiatedPlayback &&
    isPlaying &&
    currentTrack?._id &&
    currentTrack?._id === displayTrack?._id;

  // === QUEUE ACTION - EXACTLY AS YOU WANTED ===
  const handleQueueAction = async (
    action,
    trackId = null,
    playlistId = null,
    type = null,
  ) => {
    try {
      const payload = { action };

      if (action === "addPlaylistAndPlay") {
        payload.playlistId = playlistId || id;
        payload.type = type;
      } else if (action === "add" || action === "addAndPlay") {
        payload.trackId = Array.isArray(trackId) ? trackId : [trackId];
      }

      const res = await httpClient.post(
        "user/queue/queue-controller",
        payload,
        { skipLoader: true, skipErrorToast: true },
      );
      if (res.data?.success) {
        triggerQueueUpdate();
        return true;
      }
      return false;
    } catch (err) {
      console.error("Queue error:", err);
      return false;
    }
  };

  // === PLAY SINGLE SONG ===
  const playNow = async (trackId) => {
    if (!trackId) return;

    setSelectedSongId(trackId);
    setHasInitiatedPlayback(true);

    if (currentTrack?._id === trackId) {
      if (!isPlaying) await togglePlayPause();
      return;
    }

    if (typeof stopPlayback === "function") {
      stopPlayback();
    }
    await playTrackById(trackId, "audio");
  };

  // === PLAY ALL ===
  const playAllSongs = async () => {
    if (musics.length === 0) return;

    const firstSong = musics[0];
    setSelectedSongId(firstSong._id);
    setHasInitiatedPlayback(true);

    // Same first song already playing → toggle
    if (currentTrack?._id === firstSong._id) {
      if (!isPlaying) await togglePlayPause();
      return;
    }

    if (typeof stopPlayback === "function") {
      stopPlayback();
    }
    const trackIds = musics.map((m) => m._id);
    await playTrackById(trackIds, "audio");
  };

  // === TOP PLAY/PAUSE BUTTON ===
  const handleTopPlayPauseClick = async () => {
    if (!displayTrack) return;
    setHasInitiatedPlayback(true);
    if (currentTrack?._id !== displayTrack._id) {
      await playNow(displayTrack._id);
      return;
    }
    await togglePlayPause();
  };

  // === GENRE CLICK ===
  const playGenreSongs = async (genreId) => {
    setGenreLoading(genreId);
    try {
      const success = await handleQueueAction(
        "addPlaylistAndPlay",
        null,
        genreId,
        "genresong",
      );
      if (success) {
        navigate(`/party-music/${genreId}`);
        if (!isPlaying) togglePlayPause();
      }
    } catch (err) {
      alert("Failed to load genre");
    } finally {
      setGenreLoading(null);
    }
  };

  // === FETCH DATA ===
  const fetchGenresSongs = useCallback(async () => {
    try {
      const res = await httpClient.get(`/user/music/get-themes`);
      if (res.data?.success) setGenres(res.data.data.getThemes || []);
    } catch (err) {
      console.error("Error fetching genres:", err);
    }
  }, []);

  const fetchPlayMusics = useCallback(async () => {
    try {
      setLoading(true);
      const res = await httpClient.get(
        `user/music/get-admin-playlist-songs/${id}`,
      );
      if (res.data?.success) {
        const payload = res.data.data || {};
        const data = payload.songs || [];
        setMusics(data);
        const liked = new Set(data.filter((m) => m.isLiked).map((m) => m._id));
        setLikedSongs(liked);
        const name =
          payload.name ||
          payload.title ||
          payload.playlistName ||
          payload.playlist?.name ||
          data[0]?.playlistName ||
          "";
        setPlaylistInfo({ name });
      }
    } catch (err) {
      setError("Failed to load playlist");
    } finally {
      setLoading(false);
    }
  }, [id]);

  // === LIKE SONG === (optimistic update)
  const handleLikeSong = async (contentId, isLiked) => {
    const newLiked = !isLiked;

    setLikedSongs((prev) => {
      const s = new Set(prev);
      isLiked ? s.delete(contentId) : s.add(contentId);
      return s;
    });
    setMusics((prev) =>
      prev.map((m) => (m._id === contentId ? { ...m, isLiked: newLiked } : m)),
    );

    try {
      const action = isLiked ? "dislike" : "like";
      const res = await httpClient.post(
        `/user/play-history/like-content/${contentId}/${action}`,
        {},
        { skipToast: true, skipLoader: true },
      );
      if (!res.data?.success) {
        setLikedSongs((prev) => {
          const s = new Set(prev);
          newLiked ? s.delete(contentId) : s.add(contentId);
          return s;
        });
        setMusics((prev) =>
          prev.map((m) => (m._id === contentId ? { ...m, isLiked } : m)),
        );
      }
    } catch (err) {
      console.error("Like error:", err);
      setLikedSongs((prev) => {
        const s = new Set(prev);
        newLiked ? s.delete(contentId) : s.add(contentId);
        return s;
      });
      setMusics((prev) =>
        prev.map((m) => (m._id === contentId ? { ...m, isLiked } : m)),
      );
    }
  };

  // Play count is recorded only by PlayerContext (single source of truth)

  // === UTILS ===
  const formatDuration = useCallback((seconds) => {
    if (!seconds || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }, []);

  const generateShareableUrl = (id) =>
    `${process.env.REACT_APP_FRONTEND_URL || window.location.origin}music/${encodeURIComponent(id)}`;

  // `https://webmobrildemo.com/volumetv/music/${encodeURIComponent(id)}`;

  const handleCopy = async () => {
    const text = generateShareableUrl(sharePopup.song._id);
    try {
      await navigator.clipboard.writeText(text);
      alert("Copied to clipboard!");
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      alert("Copied to clipboard!");
    }
  };

  const shareOnSocialMedia = (platform, song) => {
    const url = generateShareableUrl(song._id);
    const text = encodeURIComponent(song.title);
    const links = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      twitter: `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
      whatsapp: `https://api.whatsapp.com/send?text=${text}%20${url}`,
      telegram: `https://t.me/share/url?url=${url}&text=${text}`,
    };
    window.open(links[platform], "_blank");
  };

  // === PLAYLIST MODAL ===
  const fetchPlaylists = useCallback(async () => {
    try {
      const res = await httpClient.get("/user/playlist/get-playlists");
      if (res.data?.success) setPlaylists(res.data.data.playlist || []);
    } catch (err) {
      console.error("Error fetching playlists:", err);
    }
  }, []);

  const openPlaylistModal = useCallback(
    (song, e) => {
      e.preventDefault();
      e.stopPropagation();
      setPlaylistModal({ open: true, song });
      fetchPlaylists();
      setOpenDropdown(null);
    },
    [fetchPlaylists],
  );

  const closePlaylistModal = useCallback(() => {
    setPlaylistModal({ open: false, song: null });
    setShowCreateForm(false);
    setNewPlaylist({ name: "", description: "", coverImage: null });
  }, []);

  const createNewPlaylist = async () => {
    if (!newPlaylist.name.trim()) return alert("Enter name");
    setPlaylistLoading(true);
    const fd = new FormData();
    fd.append("name", newPlaylist.name);
    fd.append("description", newPlaylist.description);
    if (newPlaylist.coverImage) fd.append("coverImage", newPlaylist.coverImage);

    try {
      const res = await httpClient.post("/user/playlist/create-playlist", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data?.success) {
        await fetchPlaylists();
        setShowCreateForm(false);
        setNewPlaylist({ name: "", description: "", coverImage: null });
        if (playlistModal.song) {
          await addToPlaylist(
            res.data.data.playlist._id,
            playlistModal.song._id,
          );
        }
      }
    } catch (err) {
      alert("Failed to create playlist");
    } finally {
      setPlaylistLoading(false);
    }
  };

  const addToPlaylist = async (playlistId, songId) => {
    try {
      const params = new URLSearchParams({
        playlistId,
        itemId: songId,
        itemType: "Music",
      });
      await httpClient.post(`/user/playlist/add-item?${params}`);
      closePlaylistModal();
    } catch (err) {
      console.error("Error adding to playlist:", err);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setNewPlaylist((prev) => ({ ...prev, coverImage: file }));
  };

  // === OUTSIDE CLICK ===
  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest(".dropdown")) setOpenDropdown(null);
      if (
        !e.target.closest(".share-popup") &&
        !e.target.closest(".single-item__export")
      )
        setSharePopup({ open: false, song: null });
      if (
        !e.target.closest(".playlist-popup") &&
        !e.target.closest(".dropdown-item")
      )
        closePlaylistModal();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [closePlaylistModal]);

  // === LIFECYCLE ===
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchGenresSongs();
  }, [fetchGenresSongs]);

  useEffect(() => {
    if (id) fetchPlayMusics();
  }, [id, fetchPlayMusics]);

  // === TOGGLE DROPDOWN ===
  const toggleDropdown = (songId, e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenDropdown((prev) => (prev === songId ? null : songId));
  };

  // === SLIDER SETTINGS ===
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  // === HELPERS ===
  const isSongCurrentlyPlaying = (songId) => currentTrack?._id === songId;
  const getQueuePosition = (songId) =>
    tracks.findIndex((t) => t._id === songId) + 1 || null;

  // === RENDER ===
  if (loading) {
    return (
      <div className="content-inner pb-0 container-fluid">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
          <div className="spinner-border text-primary"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="content-inner pb-0 container-fluid">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row row--grid">
        {/* Breadcrumb */}
        <div className="col-12">
          <ul className="breadcrumb">
            <li className="breadcrumb__item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb__item">
              <Link to="/playlist">Playlist</Link>
            </li>
            <li className="breadcrumb__item breadcrumb__item--active">
              {playlistInfo.name || displayTrack?.title || "Playlist Music"}
            </li>
          </ul>
        </div>
        <div className="col-12">
          <div className="main__title main__title--page">
            <h1>{playlistInfo.name || "Playlist Music"}</h1>
          </div>
        </div>

        {/* Main Content */}
        <div className="col-12">
          <div className="release">
            <div className="release__content">
              <div className="release__cover">
                <img
                  src={
                    displayTrack?.coverImageUrl ||
                    `${process.env.PUBLIC_URL}/img/covers/cover3.jpg`
                  }
                  alt={displayTrack?.title || "cover"}
                  style={{
                    maxHeight: "340px",
                    width: "100%",
                    height: "340px",
                    objectFit: "contain",
                    background: "#1a1a1a",
                  }}
                  onError={(e) => {
                    e.currentTarget.src = `${process.env.PUBLIC_URL}/img/covers/cover3.jpg`;
                  }}
                />
              </div>
              <div className="release__stat">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M21.65,2.24a1,1,0,0,0-.8-.23l-13,2A1,1,0,0,0,7,5V15.35A3.45,3.45,0,0,0,5.5,15,3.5,3.5,0,1,0,9,18.5V10.86L20,9.17v4.18A3.45,3.45,0,0,0,18.5,13,3.5,3.5,0,1,0,22,16.5V3A1,1,0,0,0,21.65,2.24ZM5.5,20A1.5,1.5,0,1,1,7,18.5,1.5,1.5,0,0,1,5.5,20Zm13-2A1.5,1.5,0,1,1,20,16.5,1.5,1.5,0,0,1,18.5,18ZM20,7.14L9,8.83v-3L20,4.17Z" />
                  </svg>{" "}
                  {musics.length} tracks
                </span>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M20,13.18V11A8,8,0,0,0,4,11v2.18A3,3,0,0,0,2,16v2a3,3,0,0,0,3,3H8a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H6V11a6,6,0,0,1,12,0v2H16a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h3a3,3,0,0,0,3-3V16A3,3,0,0,0,20,13.18ZM7,15v4H5a1,1,0,0,1-1-1V16a1,1,0,0,1,1-1Zm13,3a1,1,0,0,1-1,1H17V15h2a1,1,0,0,1,1,1Z"></path>
                  </svg>{" "}
                  {displayTrack?.playCount || 0}
                </span>
              </div>
              <div className="d-flex justify-content-between gap-3">
                <button
                  type="button"
                  className="release__buy open-modal"
                  onClick={handleTopPlayPauseClick}
                  disabled={!displayTrack}
                  style={{
                    cursor: displayTrack ? "pointer" : "not-allowed",
                    background: "#ff4e61",
                    color: "#fff",
                    border: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    opacity: displayTrack ? 1 : 0.6,
                  }}
                >
                  <i
                    className={
                      isDisplayTrackPlaying ? "fas fa-pause" : "fas fa-play"
                    }
                  ></i>
                  {isDisplayTrackPlaying ? "Pause" : "Play"}
                </button>
              </div>
            </div>

            {/* Songs List */}
            <div className="release__list">
              <ul className="main__list main__list--playlist main__list--dashbox">
                <h4 className="card-title text-capitalize episodes">
                  All Tracks
                </h4>
                {musics.length > 0 ? (
                  musics.map((music, i) => {
                    const contentId = music._id;
                    const isNow = isSongCurrentlyPlaying(contentId);
                    const isLiked = likedSongs.has(contentId);
                    const queuePos = getQueuePosition(contentId);
                    const ArtistId = music.artistIds?.[0] || music.artistId;
                    const isAlbhum = !!(music.albumId || music.album?._id);
                    const AlbhumId = music.albumId || music.album?._id;
                    const isDropdownOpen = openDropdown === contentId;

                    return (
                      <li
                        key={contentId}
                        className={`single-item list-1 ${isNow ? "active-episode" : ""}`}
                        style={{
                          backgroundColor: isNow ? "rgba(255,255,255,0.1)" : "",
                          borderLeft: isNow ? "3px solid #1DB954" : "",
                        }}
                      >
                        <div
                          className="single-item__cover"
                          onClick={() => playNow(contentId)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={
                              music.coverImageUrl ||
                              `${process.env.PUBLIC_URL}/img/covers/cover.svg`
                            }
                            alt={music.title}
                          />
                          {isNow && isPlaying ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              style={{ fill: "#1DB954" }}
                            >
                              <path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              style={{ fill: isNow ? "#1DB954" : "#fff" }}
                            >
                              <path d="M18.54,9L8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
                            </svg>
                          )}
                        </div>

                        <div className="single-item__title">
                          <h4
                            onClick={() =>
                              isAlbhum && navigate(`/album/${AlbhumId}`)
                            }
                            style={{
                              cursor: isAlbhum ? "pointer" : "default",
                            }}
                          >
                            {i + 1}. {music.title}
                            {isNow && (
                              <span
                                className="badge bg-success ms-2 text-white"
                                style={{ fontSize: "0.7em" }}
                              >
                                Playing
                              </span>
                            )}
                            {queuePos && !isNow && (
                              <span
                                className="badge bg-info ms-2 text-white"
                                style={{ fontSize: "0.7em" }}
                              >
                                #{queuePos}
                              </span>
                            )}
                          </h4>
                          <span
                            onClick={() =>
                              ArtistId && navigate(`/art/${ArtistId}`)
                            }
                            style={{
                              cursor: ArtistId ? "pointer" : "default",
                              color: "#1DB954",
                            }}
                          >
                            {music.artist || "Unknown"}
                          </span>
                        </div>

                        {/* Dropdown */}
                        <div className="dropdown">
                          <span
                            className={`d-flex text-white align-items-center h5 mb-0 ${
                              isDropdownOpen ? "show" : ""
                            }`}
                            onClick={(e) => toggleDropdown(contentId, e)}
                          >
                            <i className="fas fa-ellipsis-h"></i>
                          </span>
                          <div
                            className={`dropdown-menu dropdown-menu-end ${
                              isDropdownOpen ? "show" : ""
                            }`}
                            style={
                              isDropdownOpen
                                ? {
                                    position: "absolute",
                                    inset: "0px 0px auto auto",
                                    margin: "0px",
                                    transform: "translate(0px, 19px)",
                                  }
                                : {}
                            }
                          >
                            <a
                              className="dropdown-item"
                              href="#!"
                              onClick={(e) => openPlaylistModal(music, e)}
                            >
                              <span className="material-icons">
                                library_music
                              </span>{" "}
                              Add To Playlist
                            </a>

                            <a
                              className="dropdown-item"
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                handleQueueAction("add", contentId);
                                setOpenDropdown(null);
                              }}
                            >
                              <span className="material-icons">
                                playlist_add
                              </span>{" "}
                              Add To Queue
                            </a>

                            <a
                              className={`dropdown-item ${!ArtistId ? "disabled" : ""}`}
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                if (ArtistId) {
                                  navigate(`/art/${ArtistId}`);
                                  setOpenDropdown(null);
                                }
                              }}
                            >
                              <span className="material-icons">music_note</span>{" "}
                              Go To Artist
                            </a>

                            <a
                              className={`dropdown-item ${!isAlbhum ? "disabled" : ""}`}
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                if (isAlbhum) {
                                  navigate(`/album/${AlbhumId}`);
                                  setOpenDropdown(null);
                                }
                              }}
                            >
                              <span className="material-icons">album</span> Go
                              To Album
                            </a>
                          </div>
                        </div>

                        <a
                          href="#!"
                          className={`single-item__add ${isLiked ? "liked" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleLikeSong(contentId, isLiked);
                          }}
                        >
                          <i
                            className={
                              isLiked ? "fas fa-heart" : "far fa-heart"
                            }
                          ></i>
                        </a>

                        <a
                          href="#!"
                          className="single-item__export"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setSharePopup({ open: true, song: music });
                          }}
                        >
                          <i className="fas fa-share"></i>
                        </a>

                        <span className="single-item__time">
                          {isNow
                            ? `${formatDuration(seek)} / ${formatDuration(duration)}`
                            : formatDuration(music.duration)}
                        </span>
                      </li>
                    );
                  })
                ) : (
                  <li
                    className="d-flex flex-column align-items-center justify-content-center text-muted py-5"
                    style={{ listStyle: "none" }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/img/covers/cover.svg`}
                      alt="No songs"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "contain",
                        opacity: 0.6,
                        marginBottom: "16px",
                      }}
                    />
                    <h5 className="mb-1 text-white">No songs available</h5>
                    <p className="mb-0 small">
                      This playlist doesn't have any tracks yet.
                    </p>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* GENRES */}
      <div className="row">
        <div className="col-lg-12 mb-5">
          <div className="card-header mb-3">
            <div className="header-title">
              <h4 className="card-title text-capitalize">
                top song genres for you
              </h4>
            </div>
            <div className="common-album position-relative d-lg-block d-none">
              <div
                className="swiper-button-prev"
                onClick={() => sliderRef.current?.slickPrev()}
                style={{ cursor: "pointer" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
                    fill="#4A525F"
                  ></path>
                </svg>
              </div>
              <div
                className="swiper-button-next"
                onClick={() => sliderRef.current?.slickNext()}
                style={{ cursor: "pointer" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </div>
            </div>
          </div>

          <div className="swiper overflow-hidden">
            <Slider ref={sliderRef} {...sliderSettings}>
              {genres.map((g) => (
                <div key={g._id} className="swiper-slide mb-3">
                  <div
                    onClick={() => playGenreSongs(g._id)}
                    style={{ cursor: "pointer" }}
                    className="text-capitalize line-count-1 h5 d-block"
                  >
                    <img
                      src={g.themeImageUrl || `${process.env.PUBLIC_URL}/img/covers/cover.svg`}
                      className="mb-3 img-fluid rounded-3"
                      alt={g.name}
                    />
                    {genreLoading === g._id ? "Loading..." : g.name}
                  </div>
                  <small className="fw-normal text-capitalize line-count-1">
                    {g.description}
                  </small>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      {/* SHARE POPUP */}
      {sharePopup.open && sharePopup.song && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={() => setSharePopup({ open: false, song: null })}
        >
          <div
            className="share-popup"
            style={{
              backgroundColor: "#1a1a1a",
              padding: "25px",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "350px",
              color: "white",
              border: "1px solid #333",
              boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", marginBottom: "25px" }}>
              <h4
                style={{
                  margin: "0 0 10px",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#aaa7a7",
                }}
              >
                Share
              </h4>
              <p style={{ margin: 0, color: "#ccc", fontSize: "14px" }}>
                {sharePopup.song.title}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "25px",
              }}
            >
              {["facebook", "twitter", "whatsapp", "telegram"].map((p) => (
                <button
                  key={p}
                  onClick={() => shareOnSocialMedia(p, sharePopup.song)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      backgroundColor:
                        p === "facebook"
                          ? "#1877f2"
                          : p === "twitter"
                            ? "#1da1f2"
                            : p === "whatsapp"
                              ? "#25d366"
                              : "#0088cc",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className={`fab fa-${p === "twitter" ? "x-twitter" : p}`}
                      style={{ color: "white", fontSize: "20px" }}
                    ></i>
                  </div>
                  <span
                    style={{
                      display: "block",
                      fontSize: "12px",
                      marginTop: "8px",
                    }}
                  >
                    {p.charAt(0).toUpperCase() + p.slice(1)}
                  </span>
                </button>
              ))}
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <input
                type="text"
                value={generateShareableUrl(sharePopup.song._id)}
                readOnly
                style={{
                  flex: 1,
                  padding: "12px",
                  background: "#2a2a2a",
                  border: "1px solid #444",
                  borderRadius: "8px",
                  color: "white",
                  width: "50%",
                }}
              />
              <button
                onClick={handleCopy}
                style={{
                  padding: "12px 20px",
                  background: "#1DB954",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                COPY
              </button>
            </div>
            <button
              onClick={() => setSharePopup({ open: false, song: null })}
              style={{
                width: "100%",
                marginTop: "20px",
                padding: "12px",
                background: "transparent",
                color: "#ccc",
                border: "1px solid #444",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              CANCEL
            </button>
          </div>
        </div>
      )}

      {/* PLAYLIST MODAL */}
      {playlistModal.open && playlistModal.song && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={closePlaylistModal}
        >
          <div
            className="playlist-popup"
            style={{
              backgroundColor: "#1a1a1a",
              padding: "25px",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "400px",
              color: "white",
              border: "1px solid #333",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <h4
                style={{
                  margin: "0 0 10px",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Add to Playlist
              </h4>
              <p style={{ margin: 0, color: "#ccc", fontSize: "14px" }}>
                {playlistModal.song.title}
              </p>
            </div>

            {!showCreateForm ? (
              <>
                <div
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    marginBottom: "20px",
                  }}
                >
                  {playlists.length > 0 ? (
                    playlists.map((pl) => (
                      <div
                        key={pl._id}
                        style={{
                          padding: "12px",
                          border: "1px solid #333",
                          borderRadius: "8px",
                          marginBottom: "8px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={() =>
                          addToPlaylist(pl._id, playlistModal.song._id)
                        }
                      >
                        <img
                          src={
                            pl.playlistCoverUrl || "/img/live/songDefault.png"
                          }
                          alt={pl.name}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "4px",
                            objectFit: "cover",
                          }}
                        />
                        <div>
                          <div style={{ fontWeight: "500" }}>{pl.name}</div>
                          {pl.description && (
                            <div style={{ fontSize: "12px", color: "#ccc" }}>
                              {pl.description}
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#ccc",
                      }}
                    >
                      No playlists found
                    </div>
                  )}
                </div>
                <button
                  onClick={() => setShowCreateForm(true)}
                  style={{
                    width: "100%",
                    padding: "12px",
                    backgroundColor: "#1DB954",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    marginBottom: "10px",
                  }}
                >
                  Create New Playlist
                </button>
                <button
                  onClick={closePlaylistModal}
                  style={{
                    width: "100%",
                    padding: "12px",
                    background: "transparent",
                    color: "#ccc",
                    border: "1px solid #444",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  CLOSE
                </button>
              </>
            ) : (
              <div>
                <div style={{ marginBottom: "15px" }}>
                  <label style={{ display: "block", marginBottom: "5px" }}>
                    Playlist Name *
                  </label>
                  <input
                    type="text"
                    value={newPlaylist.name}
                    onChange={(e) =>
                      setNewPlaylist((p) => ({ ...p, name: e.target.value }))
                    }
                    placeholder="Enter name"
                    style={{
                      width: "100%",
                      padding: "10px",
                      background: "#2a2a2a",
                      border: "1px solid #444",
                      borderRadius: "6px",
                      color: "white",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "15px" }}>
                  <label style={{ display: "block", marginBottom: "5px" }}>
                    Description
                  </label>
                  <textarea
                    value={newPlaylist.description}
                    onChange={(e) =>
                      setNewPlaylist((p) => ({
                        ...p,
                        description: e.target.value,
                      }))
                    }
                    rows="3"
                    style={{
                      width: "100%",
                      padding: "10px",
                      background: "#2a2a2a",
                      border: "1px solid #444",
                      borderRadius: "6px",
                      color: "white",
                      resize: "vertical",
                    }}
                  />
                </div>
                <div style={{ marginBottom: "20px" }}>
                  <label style={{ display: "block", marginBottom: "5px" }}>
                    Cover Image
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    style={{
                      width: "100%",
                      padding: "8px",
                      background: "#2a2a2a",
                      border: "1px solid #444",
                      borderRadius: "6px",
                      color: "white",
                    }}
                  />
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    onClick={createNewPlaylist}
                    disabled={playlistLoading}
                    style={{
                      flex: 1,
                      padding: "12px",
                      background: "#1DB954",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      cursor: playlistLoading ? "not-allowed" : "pointer",
                      opacity: playlistLoading ? 0.7 : 1,
                    }}
                  >
                    {playlistLoading ? "Creating..." : "Create"}
                  </button>
                  <button
                    onClick={() => setShowCreateForm(false)}
                    style={{
                      flex: 1,
                      padding: "12px",
                      background: "transparent",
                      color: "#ccc",
                      border: "1px solid #444",
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminPlaylist;
